<template>
  <div>
    <my-loader :loader="loader"></my-loader>
    <club-player-tabs />

    <v-card class="filters mb-4">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-text-field
            v-model="clientSearch"
            append-icon="mdi-magnify"
            label="Поиск клиента (имя, email, телефон)"
            clearable
            dense
            outlined
            hide-details
            :disabled="loading"
            @keydown.enter="applyFilters"
            @click:clear="onClientSearchClear"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-select
            v-model="loyaltyStatusFilter"
            :items="loyaltyStatusOptions"
            label="Статус за прошлый квартал"
            clearable
            dense
            outlined
            hide-details
            :disabled="loading"
            @change="applyFilters"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card>
      <v-data-table
        mobile-breakpoint="100"
        :headers="headers"
        :items="client_list"
        item-key="user_id"
        :loading="loading"
        :items-per-page="-1"
        :hide-default-footer="true"
        :no-data-text="emptyTableText"
        class="elevation-1 club-player-clients-table"
        loading-text="Загрузка данных"
      >
        <template #[`item.name`]="{ item }">
          <a
            class="href club-player-clients-table__name"
            @click="getClubPlayerClientHistory(item)"
          >
            {{ item.name }}
          </a>
        </template>
        <template #[`item.loyalty_status`]="{ item }">
          {{ formatLoyaltyStatus(item.loyalty_status) }}
        </template>
        <template #[`item.club_player_points`]="{ item }">
          <a
            class="href"
            @click="openClientPointsModal(item)"
          >
            {{ item.club_player_points != null ? item.club_player_points : '—' }}
          </a>
        </template>
      </v-data-table>

      <div
        v-if="total_page > 1"
        class="d-flex justify-center py-4"
      >
        <v-pagination
          v-model="current_page"
          :length="total_page"
          :total-visible="7"
          :disabled="loading"
          @input="onClientsPageInput"
        />
      </div>
    </v-card>

    <v-dialog
      v-model="clubplayer_popup"
      transition="dialog-top-transition"
      max-width="1200"
      @keydown.esc="clubplayer_popup = false"
    >
      <v-card v-if="active_player">
        <v-card-title class="history-modal-title">
          <span class="text-h5">{{ active_player.name }}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="topup_points_modal = true"
          >
            Начислить баллы
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-row>
            <v-col
              cols="6"
              sm="12"
              md="12"
            >
              <span class="text-h5 history-section-title">История запросов подарков</span>
              <v-simple-table v-if="client_history">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Дата запроса
                      </th>
                      <th class="text-left">
                        Дата выдачи
                      </th>
                      <th class="text-left">
                        Подарок
                      </th>
                      <th class="text-left">
                        Статус
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in client_history.gift_requests"
                      :key="index"
                    >
                      <td>{{ item.created_at }}</td>
                      <td>{{ item.completed_at }}</td>
                      <td>{{ item.gift }}</td>
                      <td>{{ item.status }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="12"
            >
              <span class="text-h5">История начисления баллов</span>
              <v-simple-table v-if="client_history">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Дата начисления
                      </th>
                      <th class="text-left">
                        Начисление/списание
                      </th>
                      <th class="text-left">
                        Начислено за...
                      </th>
                      <th class="text-left">
                        Баллы
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in client_history.points_history"
                      :key="index"
                    >
                      <td>{{ item.date }}</td>
                      <td>
                        <template v-if="item.type == 'UP'">
                          Начисление
                        </template>
                        <template v-else>
                          Списание
                        </template>
                      </td>
                      <td>
                        <template v-if="item.yc_data">
                          {{ item.yc_data.date | formatDateTime }} |
                          {{ item.yc_data.services[0].title }}
                        </template>
                        <template v-else-if="item.comment">
                          {{ item.comment }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <td>{{ item.points_amount }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="clubplayer_popup = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="pointsPrivilegesModal"
      max-width="700"
      transition="dialog-top-transition"
    >
      <v-card v-if="active_player">
        <v-card-title>
          <span class="text-h5">{{ active_player.name }}</span>
          <span class="text-caption grey--text ml-2">ID {{ active_player.user_id }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3 points-modal-body">
          <v-progress-linear
            v-if="pointsDetailLoading"
            indeterminate
            color="primary"
            class="mb-4"
          />
          <template v-if="!pointsDetailLoading && clientDetail">
            <v-row class="points-modal-fields">
              <v-col
                cols="12"
                sm="6"
                class="points-modal-fields__points"
              >
                <div class="label">
                  Текущие баллы
                </div>
                <div class="mt-2">
                  {{ editPoints != null ? editPoints : '—' }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="points-modal-fields__status"
              >
                <div class="label">
                  Статус за прошлый квартал
                </div>
                <div class="mt-2">
                  {{ formatLoyaltyStatus(clientDetail.loyalty_status || active_player.loyalty_status) }}
                </div>
              </v-col>
            </v-row>
            <div class="mt-4">
              <div class="label mb-2">
                Привилегии (остаток на текущий квартал)
              </div>
              <v-row dense>
                <v-col
                  v-for="priv in privilegeTypeFields"
                  :key="priv.type"
                  cols="12"
                >
                  <v-text-field
                    v-model.number="loyaltyPrivileges[priv.type]"
                    type="number"
                    min="0"
                    dense
                    outlined
                    class="club-player-number-input"
                    :label="priv.label"
                    :disabled="privilegeFieldDisabled(priv.type)"
                    :hint="formatPrivilegeHint(priv.type)"
                    persistent-hint
                  />
                </v-col>
              </v-row>
            </div>
          </template>
        </v-card-text>
        <v-alert
          v-if="saveErrorMessage"
          type="error"
          dense
          text
          class="mx-4 mb-0"
        >
          {{ saveErrorMessage }}
        </v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="saving"
            :disabled="pointsDetailLoading"
            @click="saveChanges()"
          >
            Сохранить
          </v-btn>
          <v-btn
            color="error"
            class="ml-2"
            @click="pointsPrivilegesModal = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="topup_points_modal"
      max-width="500"
    >
      <v-card v-if="active_player">
        <v-card-title>
          <span class="text-h5">Ручное начисление баллов</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            ref="topupForm"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              v-model="topup_point"
              class="mt-5"
              outlined
              :rules="topup_pointRules"
              label="Кол-во баллов"
              required
            ></v-text-field>
            <v-textarea
              v-model="topup_description"
              class="mt-5"
              outlined
              :rules="topup_descriptionRules"
              label="Комментарий"
              required
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="topupLoading"
            @click="topupPoints()"
          >
            Начислить
          </v-btn>
          <v-btn
            color="error"
            @click="resetTopupForm()"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/api'
import MyLoader from '@/components/MyLoader.vue'
import ClubPlayerTabs from '@/views/club_player/ClubPlayerTabs.vue'

const LOYALTY_STATUS_LABELS = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
}

// Строки `type` должны совпадать с privilege_type в ответе GET loyalty_status
// и в теле POST adjust_loyalty_privilege (Swagger «Клубный игрок»).
const PRIVILEGE_TYPE_FIELDS = [
  {
    type: 'free_loyalty_court_canceling',
    label: 'Бесплатные отмены аренды корта (остаток, шт.)',
  },
  {
    type: 'free_loyalty_activity_record_canceling',
    label: 'Бесплатные отмены тренировок (остаток, шт.)',
  },
  {
    type: 'free_loyalty_abonement_extending',
    label: 'Бесплатное продление абонементов (остаток, дн.)',
  },
]

function emptyLoyaltyPrivileges() {
  return {
    free_loyalty_court_canceling: 0,
    free_loyalty_activity_record_canceling: 0,
    free_loyalty_abonement_extending: 0,
  }
}

function emptyLoyaltyPrivilegeMeta() {
  const meta = {}
  PRIVILEGE_TYPE_FIELDS.forEach(({ type }) => {
    meta[type] = { limit: null, used: null, disabled: false }
  })
  return meta
}

export default {
  components: { MyLoader, ClubPlayerTabs },
  filters: {
    formatDateTime(string) {
      if (!string) return ''
      const inputString = string
      const datePart = inputString.split(' ')[0]
      const timePart = inputString.split(' ')[1]
      if (!timePart) return inputString
      const [year, month, day] = datePart.split('-')
      const [hour, minute] = timePart.split(':')
      return `${day}.${month}.${year} ${hour}:${minute}`
    },
  },
  data() {
    return {
      topup_points_modal: false,
      pointsPrivilegesModal: false,
      pointsDetailLoading: false,
      saving: false,
      topupLoading: false,
      loading: false,
      loader: false,
      headers: [
        {
          text: 'ID', value: 'user_id', align: 'start', width: '70px',
        },
        { text: 'yc_id', value: 'yc_id', width: '90px' },
        { text: 'Имя', value: 'name', width: '240px' },
        { text: 'Телефон', value: 'phone', width: '130px' },
        { text: 'Email', value: 'email' },
        { text: 'Статус (квартал)', value: 'loyalty_status' },
        { text: 'Текущие баллы', value: 'club_player_points' },
      ],
      errorMessages: '',
      current_page: 1,
      total_page: null,
      pageSize: 50,
      client_list: [],
      client_history: null,
      clientDetail: null,
      clientSearch: '',
      loyaltyStatusFilter: null,
      loyaltyStatusOptions: [
        { text: 'Bronze', value: 'bronze' },
        { text: 'Silver', value: 'silver' },
        { text: 'Gold', value: 'gold' },
        { text: 'Platinum', value: 'platinum' },
      ],
      saveErrorMessage: '',
      clubplayer_popup: false,
      active_player: null,
      editPoints: null,
      editPointsOriginal: null,
      loyaltyPrivileges: emptyLoyaltyPrivileges(),
      loyaltyPrivilegesOriginal: emptyLoyaltyPrivileges(),
      loyaltyPrivilegeMeta: emptyLoyaltyPrivilegeMeta(),
      privilegeTypeFields: PRIVILEGE_TYPE_FIELDS,
      valid: true,
      topup_point: null,
      topup_pointRules: [
        v => !!v || v === 0 || 'Кол-во баллов обязательное поле',
        v => Number(v) <= 2 || 'Нельзя за один раз начислить больше 2х баллов',
      ],
      topup_description: '',
      topup_descriptionRules: [v => !!v || 'Комментарий обязательное поле'],
      /** true пока делаем router.replace из компонента — не реагировать в watcher (двойной fetch). */
      _skipRouteWatch: false,
    }
  },
  computed: {
    hasActiveFilters() {
      return !!(
        (this.clientSearch && this.clientSearch.trim())
        || this.loyaltyStatusFilter
      )
    },
    emptyTableText() {
      return this.hasActiveFilters
        ? 'По выбранным фильтрам ничего не найдено'
        : 'Участники не найдены'
    },
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        if (this._skipRouteWatch) return
        this.readFiltersFromRoute()
        this.getClubPlayerClients()
      },
    },
  },
  mounted() {
    this.readFiltersFromRoute()
    this.getClubPlayerClients()
  },
  methods: {
    formatLoyaltyStatus(value) {
      if (value == null || value === '') return '—'
      const key = String(value).toLowerCase()
      if (LOYALTY_STATUS_LABELS[key]) return LOYALTY_STATUS_LABELS[key]
      return String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase()
    },
    /** Один фрагмент query (строка или массив из router). */
    normRouteQueryPart(v) {
      if (v == null || v === '') return ''
      return String(Array.isArray(v) ? v[0] : v).trim()
    },
    /** Снимок фильтров из адресной строки (для сравнения и чтения). */
    routeQuerySignatureFromRoute(routeQuery) {
      const rq = routeQuery || {}
      let page = this.normRouteQueryPart(rq.page)
      const pn = parseInt(page, 10)
      page = Number.isFinite(pn) && pn > 1 ? String(pn) : ''
      return {
        q: this.normRouteQueryPart(rq.q),
        loyalty: this.normRouteQueryPart(rq.loyalty).toLowerCase(),
        page,
      }
    },
    /** Снимок фильтров из текущего состояния компонента. */
    routeQuerySignatureFromState() {
      const s = (this.clientSearch || '').trim()
      const page = this.current_page > 1 ? String(this.current_page) : ''
      return {
        q: s,
        loyalty: (this.loyaltyStatusFilter || '').toLowerCase(),
        page,
      }
    },
    routeQuerySignaturesEqual(a, b) {
      return a.q === b.q && a.loyalty === b.loyalty && a.page === b.page
    },
    /** Применить ?q=&loyalty=&page= из URL к полям формы (шаринг ссылки, назад/вперёд). */
    readFiltersFromRoute() {
      const sig = this.routeQuerySignatureFromRoute(this.$route.query)
      this.clientSearch = sig.q
      const allowed = this.loyaltyStatusOptions.map(o => o.value)
      if (sig.loyalty && allowed.includes(sig.loyalty)) {
        this.loyaltyStatusFilter = sig.loyalty
      } else {
        this.loyaltyStatusFilter = null
      }
      this.current_page = sig.page ? parseInt(sig.page, 10) : 1
      if (!Number.isFinite(this.current_page) || this.current_page < 1) {
        this.current_page = 1
      }
    },
    /** Записать фильтры в URL (replace), без лишних переходов и без срабатывания watcher дважды. */
    writeFiltersToRoute() {
      const next = this.routeQuerySignatureFromState()
      const cur = this.routeQuerySignatureFromRoute(this.$route.query)
      if (this.routeQuerySignaturesEqual(next, cur)) return
      const query = {}
      if (next.q) query.q = next.q
      if (next.loyalty) query.loyalty = next.loyalty
      if (next.page) query.page = next.page
      this._skipRouteWatch = true
      this.$router.replace({ path: this.$route.path, query })
        .catch(() => {})
        .finally(() => {
          this.$nextTick(() => {
            this._skipRouteWatch = false
          })
        })
    },
    onClientsPageInput() {
      this.getClubPlayerClients()
    },
    onClientSearchClear() {
      this.clientSearch = ''
      this.applyFilters()
    },
    // Query params: page, page_size, name, email, phone, loyalty_status
    buildClientParams() {
      const params = {
        page: this.current_page,
        page_size: this.pageSize,
      }
      const q = (this.clientSearch || '').trim()
      if (q) {
        if (q.includes('@')) {
          params.email = q
        } else if (/^[\d+\s()-]+$/.test(q)) {
          params.phone = q
        } else {
          params.name = q
        }
      }
      if (this.loyaltyStatusFilter) {
        params.loyalty_status = this.loyaltyStatusFilter
      }
      return params
    },
    applyFilters() {
      this.current_page = 1
      this.getClubPlayerClients()
    },
    getClubPlayerClients() {
      this.loading = true
      this.errorMessages = ''
      return Api.getClubPlayerClients({ params: this.buildClientParams() })
        .then(event => {
          this.$set(this, 'client_list', event.results || [])
          this.$set(this, 'current_page', event.current_page || this.current_page)
          this.$set(this, 'total_page', event.num_pages || 0)
        })
        .catch(error => {
          console.log(error)
          this.$set(this, 'errorMessages', 'Не удалось загрузить данные')
          this.$set(this, 'client_list', [])
          this.$set(this, 'total_page', 0)
        })
        .finally(() => {
          this.$set(this, 'loading', false)
          this.writeFiltersToRoute()
        })
    },
    applyPlayerToModal(user) {
      this.clientDetail = { ...user }
      this.editPoints = user.club_player_points != null
        ? Number(user.club_player_points)
        : null
    },
    extractApiError(error) {
      const data = error?.response?.data
      if (!data) return null
      const formatFieldErrors = value => {
        if (typeof value === 'string') return value
        if (Array.isArray(value)) return value.join(', ')
        if (value && typeof value === 'object') {
          return Object.values(value)
            .map(formatFieldErrors)
            .filter(Boolean)
            .join('; ')
        }
        return null
      }
      if (data.error != null) {
        const formatted = formatFieldErrors(data.error)
        if (formatted) return formatted
      }
      if (typeof data.detail === 'string') return data.detail
      if (Array.isArray(data.detail)) return data.detail.join(', ')
      return null
    },
    currentLoyaltyStatus() {
      const status = this.clientDetail?.loyalty_status
        ?? this.active_player?.loyalty_status
        ?? ''
      return String(status).toLowerCase()
    },
    isPrivilegesBronze() {
      return this.currentLoyaltyStatus() === 'bronze'
    },
    privilegeFieldDisabled(type) {
      return this.saving
        || this.pointsDetailLoading
        || this.isPrivilegesBronze()
    },
    getPrivilegeShortLabel(type) {
      const field = PRIVILEGE_TYPE_FIELDS.find(p => p.type === type)
      if (!field) return ''
      const match = field.label.match(/^(.+?)\s*\(остаток/)
      return match ? match[1] : field.label
    },
    humanizeSaveError(rawMessage, { privilegeType } = {}) {
      if (!rawMessage) return 'Не удалось сохранить изменения'
      const msg = String(rawMessage)
      const prefix = privilegeType ? `${this.getPrivilegeShortLabel(privilegeType)}: ` : ''
      // «Ошибка сервера» в теле ответа чаще всего соответствует 500 на бэке, не неверному JSON с фронта.
      if (msg === 'Ошибка сервера' || /ошибка сервера/i.test(msg)) {
        return `${prefix}Сервер не смог изменить привилегию. Проверьте значение или попробуйте позже.`
      }
      if (/marker-запис/i.test(msg) && /увеличить/i.test(msg)) {
        return `${prefix}Нельзя вернуть привилегию: в этом квартале нет ручных списаний, которые можно отменить. Уменьшить остаток (списать) — можно.`
      }
      if (/нельзя увеличить/i.test(msg)) {
        return `${prefix}Нельзя увеличить остаток: возврат возможен только после ручного списания в текущем квартале.`
      }
      if (/ниже\s*0|меньше нуля/i.test(msg)) {
        return `${prefix}Остаток не может быть меньше нуля.`
      }
      if (/лимит|превысить/i.test(msg)) {
        return `${prefix}Значение превышает лимит по статусу за текущий квартал.`
      }
      return prefix ? `${prefix}${msg}` : msg
    },
    formatPrivilegeHint(type) {
      if (this.isPrivilegesBronze()) {
        return 'Привилегия недоступна для статуса Bronze'
      }
      const meta = this.loyaltyPrivilegeMeta[type]
      if (!meta) return ''
      const parts = []
      if (meta.disabled) {
        parts.push('Привилегия недоступна клиенту по статусу')
      }
      if (meta.limit != null) parts.push(`Лимит: ${meta.limit}`)
      if (meta.used != null) parts.push(`Использовано: ${meta.used}`)
      return parts.join(', ')
    },
    applyBronzePrivilegeLock() {
      if (!this.isPrivilegesBronze()) return
      PRIVILEGE_TYPE_FIELDS.forEach(({ type }) => {
        this.$set(this.loyaltyPrivilegeMeta, type, {
          ...this.loyaltyPrivilegeMeta[type],
          disabled: true,
        })
      })
    },
    syncActivePlayerInList(updates) {
      const userId = this.active_player?.user_id
      if (userId == null) return
      this.active_player = { ...this.active_player, ...updates }
      const idx = this.client_list.findIndex(c => c.user_id === userId)
      if (idx >= 0) {
        this.$set(this.client_list, idx, { ...this.client_list[idx], ...updates })
      }
      this.applyPlayerToModal(this.active_player)
    },
    parseRemainsValue(val) {
      if (val == null) return 0
      if (typeof val === 'object') {
        return Number(
          val.remains ?? val.count ?? val.amount ?? val.value ?? val.balance ?? 0,
        ) || 0
      }
      return Number(val) || 0
    },
    // Разбор массива loyalty: остаток в remains. Если privilege_type с бэка
    // не совпадёт с ключами emptyLoyaltyPrivileges(), строка не попадёт в форму.
    parseLoyaltyData(loyalty) {
      const privileges = emptyLoyaltyPrivileges()
      const meta = emptyLoyaltyPrivilegeMeta()
      if (!loyalty) {
        return { privileges, meta }
      }
      if (Array.isArray(loyalty)) {
        loyalty.forEach(item => {
          const type = item.privilege_type ?? item.type ?? item.code
          if (type && Object.prototype.hasOwnProperty.call(privileges, type)) {
            privileges[type] = this.parseRemainsValue(item)
            meta[type] = {
              limit: item.limit != null ? Number(item.limit) : null,
              used: item.used != null ? Number(item.used) : null,
              disabled: !!item.disabled,
            }
          }
        })
        return { privileges, meta }
      }
      if (typeof loyalty === 'object') {
        PRIVILEGE_TYPE_FIELDS.forEach(({ type }) => {
          if (loyalty[type] != null) {
            const val = loyalty[type]
            privileges[type] = this.parseRemainsValue(val)
            if (typeof val === 'object') {
              meta[type] = {
                limit: val.limit != null ? Number(val.limit) : null,
                used: val.used != null ? Number(val.used) : null,
                disabled: !!val.disabled,
              }
            }
          }
        })
      }
      return { privileges, meta }
    },
    applyLoyaltyFromResponse(data) {
      const loyalty = data.loyalty ?? data.after?.loyalty ?? data.after
      const { privileges, meta } = this.parseLoyaltyData(loyalty)
      this.loyaltyPrivileges = { ...privileges }
      this.loyaltyPrivilegesOriginal = { ...privileges }
      this.loyaltyPrivilegeMeta = { ...meta }
      const status = data.loyalty_status
        ?? data.after?.loyalty_status
        ?? data.status
        ?? data.after?.status
      if (status) {
        this.clientDetail = {
          ...this.clientDetail,
          loyalty_status: status,
        }
        this.syncActivePlayerInList({ loyalty_status: status })
      }
      this.applyBronzePrivilegeLock()
    },
    openClientPointsModal(user) {
      this.active_player = user
      this.saveErrorMessage = ''
      this.applyPlayerToModal(user)
      this.editPointsOriginal = this.editPoints
      this.loyaltyPrivileges = emptyLoyaltyPrivileges()
      this.loyaltyPrivilegesOriginal = emptyLoyaltyPrivileges()
      this.loyaltyPrivilegeMeta = emptyLoyaltyPrivilegeMeta()
      this.pointsPrivilegesModal = true
      this.loadLoyaltyStatus(user.user_id)
    },
    // GET /club_player/loyalty_status — в query передаётся user_id (не user_pk).
    // silent: при перезагрузке после сохранения не затираем saveErrorMessage.
    loadLoyaltyStatus(userId, { silent = false } = {}) {
      this.pointsDetailLoading = true
      return Api.getClubPlayerLoyaltyStatus(userId)
        .then(data => {
          this.applyLoyaltyFromResponse(data)
        })
        .catch(error => {
          console.log(error)
          if (!silent) {
            const raw = this.extractApiError(error)
            this.saveErrorMessage = this.humanizeSaveError(raw)
              || 'Не удалось загрузить привилегии'
          }
        })
        .finally(() => {
          this.pointsDetailLoading = false
        })
    },
    // После сохранения: свежая строка из users_points + повторный loyalty_status в модалку.
    async refreshModalAfterSave({ preserveSaveError = false } = {}) {
      const userId = this.active_player?.user_id
      if (userId == null || !this.pointsPrivilegesModal) return
      const savedError = preserveSaveError ? this.saveErrorMessage : ''
      await this.getClubPlayerClients()
      const row = this.client_list.find(c => c.user_id === userId)
      if (row) {
        this.active_player = row
        this.applyPlayerToModal(row)
        this.editPointsOriginal = this.editPoints
      }
      await this.loadLoyaltyStatus(userId, { silent: true })
      if (preserveSaveError) {
        this.saveErrorMessage = savedError
      }
    },
    getPrivilegeChanges() {
      return PRIVILEGE_TYPE_FIELDS.filter(({ type }) => {
        const newVal = Number(this.loyaltyPrivileges[type]) || 0
        const oldVal = Number(this.loyaltyPrivilegesOriginal[type]) || 0
        return newVal !== oldVal
      })
    },
    // В этой модалке сохраняются только привилегии (POST adjust_loyalty_privilege).
    // Баллы только для просмотра; изменить — через историю участника → «Начислить баллы» (topup_points).
    // delta = новый остаток в поле минус предыдущий (смысл см. Swagger).
    async saveChanges() {
      const privilegeChanges = this.getPrivilegeChanges()
      if (!privilegeChanges.length) {
        return
      }
      this.saving = true
      this.saveErrorMessage = ''
      let success = false
      let lastPrivilegeType = null
      try {
        for (const { type } of privilegeChanges) {
          lastPrivilegeType = type
          const newVal = Number(this.loyaltyPrivileges[type]) || 0
          const oldVal = Number(this.loyaltyPrivilegesOriginal[type]) || 0
          // user_pk здесь = user_id участника из списка (так ожидает adjust на бэке).
          const response = await Api.adjustClubPlayerLoyaltyPrivilege({
            user_pk: this.active_player.user_id,
            privilege_type: type,
            delta: newVal - oldVal,
          })
          this.applyLoyaltyFromResponse(response)
        }
        success = true
      } catch (error) {
        console.log(error)
        const raw = this.extractApiError(error) || error?.message
        this.saveErrorMessage = this.humanizeSaveError(raw, {
          privilegeType: lastPrivilegeType,
        })
      } finally {
        this.saving = false
        if (success) {
          await this.refreshModalAfterSave()
        } else if (this.pointsPrivilegesModal && this.active_player) {
          await this.refreshModalAfterSave({ preserveSaveError: true })
        }
      }
    },
    getClubPlayerClientHistory(user) {
      this.loading = true
      this.active_player = user
      Api.getClubPlayerClientHistory(user.user_id)
        .then(event => {
          this.$set(this, 'client_history', event)
          this.$set(this, 'clubplayer_popup', true)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$set(this, 'loading', false)
        })
    },
    topupPoints() {
      if (!this.$refs.topupForm || !this.$refs.topupForm.validate()) {
        return
      }
      this.topupLoading = true
      Api.ClubPlayerTopupPoints({
        user_pk: this.active_player.user_id,
        points_amount: this.topup_point,
        comment: this.topup_description,
      })
        .then(event => {
          if (event.success) {
            this.resetTopupForm()
            const userId = this.active_player.user_id
            this.getClubPlayerClients().then(() => {
              if (this.pointsPrivilegesModal && this.active_player) {
                const row = this.client_list.find(c => c.user_id === userId)
                if (row) {
                  this.active_player = row
                  this.applyPlayerToModal(row)
                }
              }
            })
            if (this.clubplayer_popup) {
              this.getClubPlayerClientHistory(this.active_player)
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.topupLoading = false
        })
    },
    resetTopupForm() {
      if (this.$refs.topupForm) {
        this.$refs.topupForm.reset()
      }
      this.topup_points_modal = false
      this.topup_point = null
      this.topup_description = ''
    },
  },
}
</script>
<style>
.filters {
  padding: 10px;
  background-color: #e6e6eb;
  border-radius: 5px;
  margin-bottom: 20px;
}

.href {
  text-decoration: underline;
  color: #2f65ae;
  cursor: pointer;
}

.label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.search_calendar {
  margin-bottom: 20px;
  margin-top: 20px;
}

.mx-input {
  height: 48px;
}

.club-player-clients-table th:nth-child(1),
.club-player-clients-table td:nth-child(1) {
  padding-right: 8px !important;
}

.club-player-clients-table th:nth-child(2),
.club-player-clients-table td:nth-child(2) {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.club-player-clients-table th:nth-child(3),
.club-player-clients-table td:nth-child(3) {
  padding-right: 8px !important;
  white-space: nowrap;
}

.club-player-clients-table__name {
  white-space: nowrap;
}

.club-player-clients-table th:nth-child(4),
.club-player-clients-table td:nth-child(4) {
  padding-left: 8px !important;
}

.history-section-title {
  display: block;
  margin-top: 8px;
}

.points-modal-body .points-modal-fields {
  margin-top: 8px;
}

.points-modal-fields__points {
  padding-right: 32px !important;
}

@media (min-width: 600px) {
  .points-modal-fields__status {
    padding-left: 16px !important;
  }
}

.club-player-number-input input[type=number]::-webkit-inner-spin-button,
.club-player-number-input input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.club-player-number-input input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>
